'use client'

import React from 'react';
import styles from './Pricing.module.css'
import {
    Slack, Terminal, Check, Mail, Zap,
    Observr, Support, Shield, Azure,
    ArrowRight, Presentation, User_id, Card
} from '@indxsearch/pixl'
import { Button } from '@indxsearch/systm'

interface IconProps {
    color?: string;
}

export default function Pricing() {
    const renderIcon = (icon: React.ReactNode) => {
        return React.cloneElement(icon as React.ReactElement<IconProps>, {
            color: 'currentColor',
        });
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.inside}>
                <h2 id="pricing" className={styles.heading}>Pricing</h2>
                <div className={styles.containers}>
                    <div className={styles.community}>
                        <h3>Community</h3>
                        <div className={styles.priceContainer}>
                            <span className={styles.price}>Free</span>
                        </div>
                        <p className={styles.subtitle}>Every search feature. No usage limits.</p>
                        <p className={styles.description}>Ideal for developers, startups, and teams who can self-support through documentation and community resources.</p>
                        <ul>
                            <li>
                                {renderIcon(<Slack />)}
                                Community support
                            </li>
                            <li>
                                {renderIcon(<Terminal />)}
                                Open Source developer toolkit
                            </li>
                            <li>
                                {renderIcon(<Check />)}
                                Full production use allowed
                            </li>
                        </ul>
                        <Button
                            variant='secondary'
                            iconRight={<User_id/>}
                            href="https://license.indx.co"
                        >Get a free license</Button>
                    </div>
                    <div className={styles.professional}>
                        <h3>Professional</h3>
                        <div className={styles.priceContainer}>
                            <span className={styles.price}>€ 250</span>
                            <span className={styles.period}>/month</span>
                        </div>
                        <p className={styles.subtitle}>Priority support from the Indx team</p>
                        <p className={styles.description}>Great for teams building applications where reliability matters.</p>
                        <ul>
                            <li>
                                {renderIcon(<Observr />)}
                                Includes Observr usage
                            </li>
                            <li>
                                {renderIcon(<Mail />)}
                                Priority e-mail support
                            </li>
                            <li>
                                {renderIcon(<Zap />)}
                                Integration & deployment guidance
                            </li>
                        </ul>
                        <Button
                            variant='primary'
                            href="https://license.indx.co"
                            iconRight={<Card/>}
                        >Subscribe with Stripe</Button>
                    </div>
                    <div className={styles.enterprise}>
                        <h3>Enterprise SLA</h3>
                        <div className={styles.priceContainer}>
                            <span className={styles.price}>Contact us</span>
                        </div>
                        <p className={styles.subtitle}>Guaranteed response times and dedicated support.</p>
                        <p className={styles.description}>For mission-critical workloads. We'll ensure your search application succeeds.</p>
                        <ul>
                            <li>
                                {renderIcon(<Support />)}
                                Direct engineering access
                            </li>
                            <li>
                                {renderIcon(<Shield />)}
                                Uptime SLA & guaranteed response times
                            </li>
                            <li>
                                {renderIcon(<Azure />)}
                                Azure deployment assistance
                            </li>
                        </ul>
                        <Button
                            variant='primary'
                            iconRight={<Presentation/>}
                            href="https://lfut1rkw3es.typeform.com/to/Mdqgj4ho"
                        >Book a meeting</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}